import Cookies from "universal-cookie";
import InterAxios from "../Service/InterAxios";

export const getGalleryPage = async (galleryId, page = 1) => {

    const cookies = new Cookies();
    const interAxios = new InterAxios('App', () => cookies.get('authtoken')?.token);

    return new Promise((resolve, reject) => {
        interAxios.get('/galleries/images?limit=18&page=' + page + '&galleryId=' + galleryId, function(response) {
            resolve(response.data);
        }, function(error) {
            reject(error.response?.data);
        });
    });

}